<template>
  <div class="px-8 py-6" style="height:100%; width:100%;">
    <h3>업체관리</h3>
    <div class="d-flex pb-5 pt-5">
      <div class="pr-5">
        <v-select
          v-resize="updateWindowHeight"
          class="border-5c5c5c width160-height30"
          height="28"
          :items="searchList"
          solo
          flat
          dense
          v-model="searchCategory"
          label="업체구분"
          :menu-props="{ offsetY: true }"
        />
      </div>
      <div class="pr-5">
        <input
          class="border-width border-5c5c5c back-white "
          v-model="searchWord"
          @keyup.enter="searchCompany"
        />
      </div>
      <v-btn
        solo
        width="78"
        height="30"
        color="#3F557D"
        class="color-white"
        @click="searchCompany"
      >
        조회
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        width="120"
        height="30"
        color="#FFFFFF"
        class="text-none add-btn"
        @click="$bus.$emit('addCompanyOn')"
        >업체추가</v-btn
      >
    </div>
    <div class="pt-3">
      <v-simple-table
        class="width-100"
        :height="windowInnerHeight - 48 - 170"
        fixed-header
        dense
      >
        <thead>
          <th
            class="back-8ca9dd color-white border-right-white border-left-aaaaaa"
            v-for="item in header"
            :key="item"
            style="font-size: 0.75rem;"
          >
            {{ item }}
          </th>
        </thead>
        <tbody>
          <tr
            v-for="list in companyList"
            :key="list.companyId"
            class="text-left"
          >
            <td
              class="border-right-aaaaaa border-bottom-aaaaaa border-left-aaaaaa  color-0038FF text-left pl-1"
            >
              <v-btn
                @click="$bus.$emit('addCompanyOn', list.companyId)"
                color="#0038FF"
                text
              >
                {{ list.companyName }}
              </v-btn>
            </td>
            <td
              class="border-left-aaaaaa border-right-aaaaaa border-bottom-aaaaaa text-left pl-1"
            >
              {{ list.companyType }}
            </td>

            <td class="border-right-aaaaaa border-bottom-aaaaaa text-left pl-1">
              {{ list.registDate | moment("YY.MM.DD") }}
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </div>
    <AddCompany />
  </div>
</template>

<script>
import CompanyApi from "@/api/CompanyService";
import AddCompany from "./AddCompany.vue";
import Commonality from "@/mixin/Commonality";
export default {
  mixins: [Commonality],
  components: {
    AddCompany,
  },
  data: () => ({
    companyList: [],
    searchList: ["업체구분", "회사명"],
    searchCategory: "",
    companyTotalList: [],
    searchWord: "",
    header: ["회사명", "업체구분(권한)", "등록일자"],
    windowInnerHeight: 0,
  }),
  created() {
    this.$bus.$on("constructionNavigationDuplicated", () => {
      this.startAndReset();
    });
    this.startAndReset();
  },
  beforeDestroy() {
    this.$bus.$off("constructionNavigationDuplicated");
  },
  methods: {
    /** 윈도우 동적높이 가져오는 함수 */
    updateWindowHeight() {
      if (typeof window !== "undefined") {
        this.windowInnerHeight = window.innerHeight;
      }
    },
    async startAndReset() {
      let data = { constructionId: null };
      if (this.userState == "현장관리자")
        data.constructionId = this.constructionId;
      let returnData = await CompanyApi.companyTotalList(data);
      this.companyTotalList = returnData.data.companyList;
      this.companyList = this.companyTotalList;
      this.searchCategory = "업체구분";
    },
    searchCompany() {
      if (this.searchWord == "")
        return (this.companyList = this.companyTotalList);
      if (this.searchCategory == "업체구분") {
        this.companyList = this.companyTotalList.filter((companyList) =>
          companyList.companyType
            ? companyList.companyType.includes(this.searchWord)
            : false
        );
      } else if (this.searchCategory == "회사명") {
        this.companyList = this.companyTotalList.filter((companyList) =>
          companyList.companyName
            ? companyList.companyName.includes(this.searchWord)
            : false
        );
      }
    },
  },
};
</script>

<style scoped lang="scss">
.v-data-table--fixed-header.v-data-table--dense
  > .v-data-table__wrapper
  > table
  > thead {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 10;
}
th {
  height: 30px;
}

.border-width {
  width: 300px;
  height: 30px;
}

.width160-height30 {
  width: 160px !important;
  height: 30px !important;
}

.add-btn {
  border-color: black !important;
  border: 1px solid black;
}
@media (max-width: 1000px) {
  .width-100 {
    width: 1605px !important;
  }
}
</style>
